import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_order_substatuses_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { state_definitions?: { name: string, order_filter: string }[], parent_status_ids?: number[], $top?: number, $skip?: number }): Promise<{ result?: { name?: string, order_filter?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { state_definitions?: { name: string, order_filter: string }[], parent_status_ids?: number[], $keys: { name?: string, order_filter?: string }[] }): Promise<{ result?: { name?: string, order_filter?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      state_definitions?: { name: string, order_filter: string }[], parent_status_ids?: number[]    }) {
      return false;
    }
}
